// src/composables/useDatatablePagination.js (version finale et centralisée)

import { ref, watch } from '@vue/composition-api'
import {
  ROWS_PER_PAGE_ITEMS,
  DEFAULT_ROWS_PER_PAGE,
  LOCAL_STORAGE_KEY,
} from '@/config/datatable'

// Fonctions privées du module
const getFromStorage = () => {
  try {
    const storedValue = localStorage.getItem(LOCAL_STORAGE_KEY)
    return storedValue ? parseInt(storedValue, 10) : DEFAULT_ROWS_PER_PAGE
  } catch {
    return DEFAULT_ROWS_PER_PAGE
  }
}

const saveToStorage = value => {
  localStorage.setItem(LOCAL_STORAGE_KEY, value)
}

/**
 * Le Composable de pagination pour les datatables.
 * Gère l'état réactif et la persistance dans le localStorage.
 */
export function useDatatablePagination() {
  // 1. On crée les variables réactives (ref)
  const options = ref({
    page: 1,
    itemsPerPage: getFromStorage(),
    // sortBy: [false],
    sortDesc: [true],
  })

  const rowsPerPageItems = ref(ROWS_PER_PAGE_ITEMS)

  // 2. On crée le watch ICI, à l'intérieur du composable !
  watch(
    () => options.value.itemsPerPage,
    newValue => {
      if (newValue) {
        saveToStorage(newValue)
      }
    },
  )

  // 3. On retourne les variables réactives pour que le composant puisse les utiliser
  return {
    options,
    rowsPerPageItems,
  }
}
